import _ from 'underscore';
import {
  SUPPORT_APPLY_TYPES,
  SUPPORT_DOWNLOAD_TYPES,
  SUPPORT_DISMISS_TYPES,
  SUPPORT_RESUBMIT_TYPES,
  SUPPORT_DATE_FILTER_TYPES,
} from '@bingads-webui-campaign/recommendation-grid';
import {
  RECOMMENDATION_CATEGORIES,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

export function getToolbarConfig({
  onSelectCrossPage,
  onEvent,
  newI18n,
  i18n,
  recommendationType,
  gridView,
  readOnly,
  compact,
  context,
}) {
  const dismissBtnId = 'button-dismiss';
  const undismissBtnId = 'button-undismiss';
  const applyBtnId = 'button-apply';
  // eslint-disable-next-line
  const toolbarUnselectedConfig = new Map();
  if (!compact) {
    toolbarUnselectedConfig.set('button-recommendation-more', {
      id: 'button-more',
      type: 'button',
      iconLeftGlyphName: 'ba-Back',
      text: i18n.getString('Recommendation_More'),
      classes: ['btn', 'btn-navigate-back'],
      noResponsive: true,
      onClick: () => {
        onEvent('back');
      },
    });
    toolbarUnselectedConfig.set('expander', {
      type: 'expander',
    });
  }

  if (_.contains(SUPPORT_DATE_FILTER_TYPES, recommendationType)) {
    toolbarUnselectedConfig.set('dropdown-date-filter', {
      type: 'dropdown',
      button: {
        text: i18n.getString('Dropdown_Button_LastSixMonth'),
      },
      id: 'dropdown-date-filter',
      menu: {
        items: [{
          text: i18n.getString('Dropdown_Menu_LastThreeMonth'),
          id: 'dropdown-item-lastthreemonth',
        },
        {
          text: i18n.getString('Dropdown_Menu_LastSixMonth'),
          id: 'dropdown-item-lastsixmonth',
        }],
      },
    });
  }

  if (_.contains(SUPPORT_DOWNLOAD_TYPES, recommendationType)) {
    toolbarUnselectedConfig.set('button-download', {
      type: 'nav-item',
      id: 'button-download',
      iconLeftGlyphName: 'ba-Download',
      text: i18n.getString('Details_View_Download_All'),
      noResponsive: true,
    });
  }

  if (!compact) {
    if (_.result(context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED) {
      toolbarUnselectedConfig.set('button-undismiss-all', {
        type: 'nav-item',
        id: 'button-undismiss-all',
        iconLeftGlyphName: 'ba-Undo',
        text: newI18n.getString(_TL_('Undismiss all')),
        noResponsive: true,
        disabled: readOnly,
      });
    } else {
      toolbarUnselectedConfig.set('reject-help-popup', {
        type: 'custom',
        id: 'reject-help-popup',
        disabled: readOnly,
      });
    }
  }

  // eslint-disable-next-line
  const toolbarSelectedConfig = new Map();
  toolbarSelectedConfig.set('selection-widget', {
    type: 'selection-widget',
    onSelectCrossPage,
  });

  if (_.contains(SUPPORT_APPLY_TYPES, recommendationType) ||
  _.contains(SUPPORT_RESUBMIT_TYPES, recommendationType)) {
    toolbarSelectedConfig.set('divider', {
      type: 'divider',
    });
  }

  if (_.contains(SUPPORT_APPLY_TYPES, recommendationType)) {
    toolbarSelectedConfig.set(applyBtnId, {
      type: 'button',
      id: applyBtnId,
      iconLeftGlyphName: 'ba-Accept',
      text: i18n.getString('Button_Apply'),
      classes: ['btn-primary'],
      disabled: readOnly,
    });
  }

  if (_.contains(SUPPORT_RESUBMIT_TYPES, recommendationType)) {
    toolbarSelectedConfig.set(applyBtnId, {
      type: 'button',
      id: applyBtnId,
      iconLeftGlyphName: 'ba-Accept',
      text: i18n.getString('Button_Resubmit'),
      classes: ['btn-primary'],
      disabled: readOnly || (!_.isUndefined(gridView) && !_.some(
        gridView.selectedItems(),
        selectedItem => _.first(selectedItem.Opportunities).IsAppealable
      )),
    });
  }

  if (recommendationType === RECOMMENDATION_TYPES.IMAGE_EXTENSION) {
    let disabled = false;
    if (!_.isUndefined(gridView) && !readOnly) {
      _.each(gridView.selectedItems(), (selectedItem) => {
        const opporunity = _.first(selectedItem.Opportunities);
        const stockImages = opporunity.StockImages;
        if ((!_.isEmpty(stockImages) && _.isEmpty(_.first(stockImages).ThumbnailURL))) {
          disabled = true;
        }
      });
    } else {
      disabled = true;
    }

    toolbarSelectedConfig.set(applyBtnId, {
      type: 'button',
      id: applyBtnId,
      iconLeftGlyphName: 'ba-Accept',
      text: i18n.getString('Button_Apply'),
      classes: ['btn-primary'],
      disabled,
    });
  }

  if (_.contains(SUPPORT_APPLY_TYPES, recommendationType) ||
  _.contains(SUPPORT_RESUBMIT_TYPES, recommendationType)) {
    toolbarSelectedConfig.set('expander', {
      type: 'expander',
    });
  }

  if (_.contains(SUPPORT_DISMISS_TYPES, recommendationType)) {
    if (_.result(context, 'Category', '') === RECOMMENDATION_CATEGORIES.DISMISSED) {
      toolbarSelectedConfig.set(undismissBtnId, {
        type: 'button',
        id: undismissBtnId,
        iconLeftGlyphName: 'ba-Undo',
        text: newI18n.getString(_TL_('Undismiss')),
        classes: ['btn-primary'],
        disabled: readOnly,
      });
    } else {
      toolbarSelectedConfig.set(dismissBtnId, {
        type: 'button',
        id: dismissBtnId,
        iconLeftGlyphName: 'ba-RemoveContent',
        text: i18n.getString('Button_Dismiss'),
        classes: ['btn-primary'],
        disabled: readOnly,
      });
    }
  }

  toolbarSelectedConfig.set('button-clear-selection', {
    type: 'button-clear-selection',
  });

  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
